<!--
An input on which all vee validation rules can be applied throught the "rules" prop.
See vee-validationrules.ts for list of available rules

Example use : 
 <InputWithValidation
    rules="required|email"
    type="email"
    :tooltip="$t('input-email-tooltip')"
    :label="$t('input-email')"
    placeholder="e.g. EXAMPLE VALUE"
    v-model="email"
  />
-->
<template>
  <ValidationProvider
    v-slot="{ errors, handleChange, handleBlur }"
    :vid="(group != '' ? group + '_' : '') + vid"
    :name="($attrs.name as string) || ($attrs.label as string)"
    :rules="rules"
    :model-value="innerValue"
    @update:model-value="updateValue"
  >
    <b-checkbox
      v-model="innerValue"
      :disabled="disabled"
      @update:model-value="
        (val: any) => {
          handleChange && handleChange(val)
        }
      "
      @blur="(event: any) => handleBlur && handleBlur(event)"
    >
      <slot></slot>
    </b-checkbox>
    <p v-if="rules && errors.length > 0" class="help is-danger">
      <span v-if="errorMessage.length > 0"> {{ errorMessage }}</span
      ><span v-else>
        {{ errors[0] }}
      </span>
    </p>
  </ValidationProvider>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import ValidationProvider from "@/services/validation/ValidationProvider.vue"
import { BCheckbox } from "buefy"

export default defineComponent({
  name: "CheckboxWithValidation",
  components: {
    ValidationProvider,
    BCheckbox,
  },
  props: {
    group: {
      type: String,
      default: "",
    },
    vid: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
    modelValue: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue", "manual-change"],
  data() {
    return {
      innerValue: false,
    }
  },
  watch: {
    innerValue(newVal: boolean, _oldValue: boolean): void {
      this.$emit("update:modelValue", newVal)
    },
    modelValue(newVal: boolean, _oldValue: boolean): void {
      this.innerValue = newVal
      if (newVal != _oldValue) {
        this.$emit("manual-change", newVal)
      }
    },
  },
  created(): void {
    if (this.modelValue) {
      this.innerValue = this.modelValue
    }
  },
  methods: {
    updateValue(newValue: boolean): void {
      this.innerValue = newValue
      // Émettre immédiatement pour synchroniser avec le parent
      this.$emit("update:modelValue", newValue)
    },
  },
})
</script>
